module.exports = __webpack_public_path__ + "img/art-tiao-icon1.17bb859d.png";